import React, { useState } from "react";
import "../supplierAndManufacturers.scss";
import { TabItem } from "./HeaderTabs";
import DataBlock from "./DataBlock";
import SubscriptionsBlock from "./SubscriptionsBlock";

export const Menu = [{
  id: 0,
  label: 'Tools'
},
{
  id: 1,
  label: 'Products'
},
{
  id: 2,
  label: 'Services'
},
{
  id: 3,
  label: 'Packages'
},
{
  id: 4,
  label: 'Storefront products'
},]

export const ClientMenu = [{
  id: 0,
  label: 'Subscriptions'
}]

const ViewBody = ({
  isForClient = false,
  data = {},
  itemId = 0,
  isSupplier = false,
  clientId = 0,
}) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState(Menu[0])
  return (
    <div className="viewBody">
      <div className="label">Associations</div>

      <Header selectedMenuItem={selectedMenuItem} setSelectedMenuItem={setSelectedMenuItem} isForClient={isForClient} />
      {/* <NoData /> */}
      {isForClient ? <SubscriptionsBlock data={data?.Subscription_Detail} clientId={clientId} /> : <DataBlock data={data} selectedMenuItem={selectedMenuItem} itemId={itemId} isSupplier={isSupplier} />}

    </div>
  )
}

export default ViewBody;

const Header = ({
  selectedMenuItem,
  isForClient = false,
  setSelectedMenuItem = () => { }
}) => (
  <div className="header">
    <div className="headerTabs">
      {
        (isForClient ? ClientMenu : Menu)?.map((menuItem) => {
          return (
            <TabItem
              name={menuItem?.label}
              isSelected={menuItem?.id === selectedMenuItem?.id}
              onClick={() => { setSelectedMenuItem(menuItem) }}
            />
          )
        })
      }
    </div>
  </div>
)

export const NoData = () => (
  <div className="noDataBlock text-center">
    <img src={'/images/settings-nav/supplier_and_manufacturers_no_data.svg'} width={15} height={17} alt="data icon" className="mx-2 mb-1 mt-5" />
    <div className="text">No associations yet</div>
  </div>
)
